import { createContext, useContext } from "react";
import { FeatureFlag } from "./activeFlags";

// isReady: false only while a remote provider is still fetching its first values, when every flag
// reads its registry default. The local checker has nothing to wait for.
export const FeatureFlagContext = createContext({
  isFeatureActive: FeatureFlag.isFeatureActive,
  isReady: true,
});

export const useFeatureFlags = () =>
  useContext(FeatureFlagContext).isFeatureActive;

/** Whether flags have their real values yet; until then each reads its registry default. */
export const useFeatureFlagsReady = () => useContext(FeatureFlagContext).isReady !== false;

export const useFeatureFlag = (flagName) => useFeatureFlags()(flagName);
